module.exports = __webpack_public_path__ + "static/img/fundamentals-icon.00178fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/fundamentals-icon.png
// module id = z/Ou
// module chunks = 0